import { cn } from "~/lib/cn";

const icons = {
  // DS §11 default — milestone / unlock (padlock)
  default: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true">
      <path d="M12 17a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6-9h-1V6a5 5 0 1 0-10 0v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM9 6a3 3 0 1 1 6 0v2H9V6z" />
    </svg>
  ),
  success: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true">
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
  ),
  warning: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
      aria-hidden="true"
    >
      <path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
    </svg>
  ),
} as const;

type ToastVariant = keyof typeof icons;

interface ToastProps {
  message: string;
  /** DS §11 mono line above the title («Atención», «Técnica desbloqueada»). */
  eyebrow?: string;
  visible: boolean;
  variant?: ToastVariant;
  /** DS §11 surface modifier — the default pill is built for dark stages. */
  onLight?: boolean;
  /** `alert` for a failed action she has to act on; the default announces politely. */
  role?: "status" | "alert";
  className?: string;
}

export function Toast({ message, eyebrow, visible, variant = "default", onLight, role = "status", className }: ToastProps) {
  return (
    <div
      className={cn("ds-toast-host", visible && "is-visible", className)}
      role={role}
      aria-live={role === "alert" ? "assertive" : "polite"}
      aria-atomic="true"
    >
      <div className={cn("ds-toast", onLight && "on-light")}>
        <span className={cn("ds-toast-icon", variant !== "default" && variant)}>
          {icons[variant]}
        </span>
        {eyebrow ? (
          <div>
            <div className="ds-toast-eyebrow">{eyebrow}</div>
            <div className="ds-toast-title">{message}</div>
          </div>
        ) : (
          <span className="ds-toast-title">{message}</span>
        )}
      </div>
    </div>
  );
}
